import { render, staticRenderFns } from "./chat-cliente-escopo.vue?vue&type=template&id=35ef80d8&scoped=true&"
import script from "./chat-cliente-escopo.vue?vue&type=script&lang=js&"
export * from "./chat-cliente-escopo.vue?vue&type=script&lang=js&"
import style0 from "./chat-cliente-escopo.vue?vue&type=style&index=0&id=35ef80d8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ef80d8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35ef80d8')) {
      api.createRecord('35ef80d8', component.options)
    } else {
      api.reload('35ef80d8', component.options)
    }
    module.hot.accept("./chat-cliente-escopo.vue?vue&type=template&id=35ef80d8&scoped=true&", function () {
      api.rerender('35ef80d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/aawz-intelligence-v2/components/chat-cliente-escopo/chat-cliente-escopo.vue"
export default component.exports